import React from "react";

const AddStudentToClassIcon = () => {
  return (
    <svg viewBox="0 0 14 14">
      <g transform="translate(-12 -12)">
        <path d="M18,12a2.667,2.667,0,1,0,2.667,2.667A2.668,2.668,0,0,0,18,12Zm0,1.333a1.333,1.333,0,1,1-1.333,1.333A1.336,1.336,0,0,1,18,13.333ZM22,18a3.99,3.99,0,0,0-3.029,1.4A8.937,8.937,0,0,0,18,19.333c-2.094,0-6,1.031-6,3V24h6.544A4,4,0,1,0,22,18Zm-.667,2h1.333v1.333H24v1.333H22.667V24H21.333V22.667H20V21.333h1.333ZM18,20.667c.076,0,.154.01.229.013A3.974,3.974,0,0,0,18,22a3.756,3.756,0,0,0,.063.667H13.333v-.333C13.333,21.755,15.8,20.667,18,20.667Z" />
      </g>
    </svg>
  );
};

export default AddStudentToClassIcon;
